import { useState, useEffect } from 'react';
import { GenericCard, FeatureCard, StatCard } from '@/components/cards';
import { TitleLarge, TitleMedium, BodyRegular, BodySmallMedium, BodyBold } from '@/components/typography';
import { PrimaryButton } from '@/components/buttons';
// Render non-blocking videos with
import { LazyVideo } from '@/components/elements';
// Trust & Security icons
import AuditIcon from '@/assets/img/ui/1.png';
import LockIcon from '@/assets/img/ui/12.png';
import GovernIcon from '@/assets/img/ui/16.png';
import PublicIcon from '@/assets/img/ui/17.png';
// Animations
import HeroAnim from '@/assets/anim/home-hero.webm';
import IntroAnim from '@/assets/anim/home-intro.webm';
// Features
import AnonImage from '@/assets/img/ui/Anon-1.png';
// import StakingImage from '@/assets/img/ui/22.png';
import StakingImage from '@/assets/img/ui/staking.png';
import BullshitPieChartImage from '@/assets/img/ui/PieLayer.png';
import GovernanceImage from '@/assets/img/ui/23.png';
// Community – platform logo images
import TwitterLogo from '@/assets/img/icon/big/x-com.svg';
import TelegramLogo from '@/assets/img/icon/big/telegram.svg';
import DiscordLogo from '@/assets/img/icon/big/discord.svg';
import KickLogo from '@/assets/img/icon/big/kick.svg';
import YouTuveLogo from '@/assets/img/icon/big/youtube.svg';

import BlockImage from "@/assets/img/ui/24.png";
import ChainImage from "@/assets/img/ui/25.png";

import { 
    BodyXLMedium,
    BodySmallRegular
} from '@/components/typography';

interface TimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export const Home = () => {
    const [timeLeft, setTimeLeft] = useState<TimeLeft>({
        days: 21,
        hours: 14,
        minutes: 15,
        seconds: 56
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                let { days, hours, minutes, seconds } = prev;
                
                seconds--;
                if (seconds < 0) {
                    seconds = 59;
                    minutes--;
                }
                if (minutes < 0) {
                    minutes = 59;
                    hours--;
                }
                if (hours < 0) {
                    hours = 23;
                    days--;
                }
                if (days < 0) {
                    clearInterval(timer);
                    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
                }
                
                return { days, hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleICOButtonClick = () => {
        const scrollY = (document.querySelector('footer') as HTMLElement).offsetTop;

        window.scrollTo(0, scrollY);
    }

    return (
        <div className="w-full">
            {/* Hero Section */}
            <section className="relative w-full flex items-center justify-center overflow-hidden px-4 py-16 lg:min-h-screen">
                {/* Main content container */}
                <div className="relative z-10 w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-center lg:flex-row lg:items-center gap-8 lg:gap-12">
                    {/* Left side - Text content */}
                    <div className="w-full lg:flex-1 flex flex-col items-start gap-8 lg:gap-12 max-w-[320px] lg:max-w-[656px]">
                        <div className="flex flex-col gap-4 lg:gap-10">
                            <div className="flex flex-col gap-4 lg:gap-6">
                                <TitleLarge className="text-left">
                                    <span className="text-white">Where Meme meets market – and </span>
                                    <span className="text-primary">AI writes the script</span>
                                    <span className="text-white">.</span>
                                </TitleLarge>
                                
                                <BodyRegular className="text-white/80 max-w-full lg:max-w-[530px]">
                                    Crypto Crap (CCRAP) fuses humour, artificial intelligence, and finance 
                                    to create a meme-powered ecosystem where every laugh earns real value.
                                </BodyRegular>
                            </div>
                        </div>

                        <div className="w-full max-w-[320px] lg:max-w-[400px] flex flex-col gap-4 lg:gap-6">
                            <PrimaryButton className="w-full" onClick={handleICOButtonClick}>
                                Join the ICO
                            </PrimaryButton>
                        </div>
                    </div>

                    {/* Right side - Timer */}
                    <div className="flex-1 flex items-center justify-center relative w-full max-w-[320px] lg:max-w-none mt-48 lg:mt-0">
                        <LazyVideo
                            src={HeroAnim}
                            className="absolute pointer-events-none scale-x-[-1] left-2/3 lg:left-1/2 -top-1 lg:top-1/2 -translate-x-1/2 -translate-y-1/2 w-[280vw] max-w-[1180px] lg:w-auto lg:min-w-[1920px] lg:h-[1080px]"
                        />
                        <div className="w-full flex flex-col items-center justify-center p-4 gap-2 h-32 lg:w-96 lg:h-40 relative bg-gradient-to-br from-white/20 to-white/5 rounded-3xl shadow-[0px_0.9585345387458801px_23.963363647460938px_0px_rgba(69,42,124,0.10)] border-2 border-white/10 backdrop-blur-xl overflow-hidden">
                            {/* Title */}
                            <div className="">
                                <BodyRegular className="text-white/80">
                                    The First AI-Generated NFT Auction
                                </BodyRegular>
                            </div>
                            
                            {/* Countdown Container */}
                            <div className="w-full nline-flex flex-col justify-center items-start gap-6">
                                <div className="w-full h-16 lg:w-auto lg:h-auto inline-flex justify-start items-center gap-1.5">
                                    {/* Days */}
                                    <div className="flex-1 lg:flex-none h-16 lg:h-auto lg:p-4 bg-gray-900/10 rounded-2xl flex justify-center items-center gap-2.5">
                                        <div className="w-10 inline-flex flex-col justify-center lg:justify-start items-center">
                                            <BodyBold className="text-center text-primary">
                                                {timeLeft.days.toString().padStart(2, '0')}
                                            </BodyBold>
                                            <BodySmallMedium className="text-white/80">
                                                day
                                            </BodySmallMedium>
                                        </div>
                                    </div>
                                    
                                    <BodySmallMedium className="text-white/80">:</BodySmallMedium>
                                    
                                    {/* Hours */}
                                    <div className="flex-1 lg:flex-none h-16 lg:h-auto lg:p-4 bg-gray-900/10 rounded-2xl flex justify-center items-center gap-2.5">
                                        <div className="w-10 inline-flex flex-col justify-center lg:justify-start items-center">
                                            <BodyBold className="text-center text-primary">
                                                {timeLeft.hours.toString().padStart(2, '0')}
                                            </BodyBold>
                                            <BodySmallMedium className="text-white/80">
                                                hour
                                            </BodySmallMedium>
                                        </div>
                                    </div>
                                    
                                    <BodySmallMedium className="text-white/80">:</BodySmallMedium>
                                    
                                    {/* Minutes */}
                                    <div className="flex-1 lg:flex-none h-16 lg:h-auto lg:p-4 bg-gray-900/10 rounded-2xl flex justify-center items-center gap-2.5">
                                        <div className="w-10 inline-flex flex-col justify-center lg:justify-start items-center">
                                            <BodyBold className="text-center text-primary">
                                                {timeLeft.minutes.toString().padStart(2, '0')}
                                            </BodyBold>
                                            <BodySmallMedium className="text-white/80">
                                                min
                                            </BodySmallMedium>
                                        </div>
                                    </div>
                                    
                                    <BodySmallMedium className="text-white/80">:</BodySmallMedium>
                                    
                                    {/* Seconds */}
                                    <div className="flex-1 lg:flex-none h-16 lg:h-auto lg:p-4 bg-gray-900/10 rounded-2xl flex justify-center items-center gap-2.5">
                                        <div className="w-10 inline-flex flex-col justify-center lg:justify-start items-center">
                                            <BodyBold className="text-center text-primary">
                                                {timeLeft.seconds.toString().padStart(2, '0')}
                                            </BodyBold>
                                            <BodySmallMedium className="text-white/80">
                                                sec
                                            </BodySmallMedium>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Trust & Security Section */}
            <section className="w-full flex justify-center px-4 py-8 lg:py-16">
                <div className="w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-center gap-8 lg:gap-12">
                    {/* Section Header */}
                    <div className="flex flex-col items-center gap-4 mb-4 lg:mb-0">
                        <TitleMedium className="text-center">
                            <span className="text-white">Trust & </span>
                            <span className="text-primary">Security</span>
                        </TitleMedium>
                    </div>

                    {/* Cards Grid */}
                    <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-4">
                        <GenericCard
                            image={AuditIcon}
                            title="Audited Smart Contracts"
                        />
                        <GenericCard
                            image={LockIcon}
                            title="Locked Liquidity"
                        />
                        <GenericCard
                            image={GovernIcon}
                            title="Governance Oversight"
                        />
                        <GenericCard
                            image={PublicIcon}
                            title="Public Treasury"
                        />
                    </div>
                </div>
            </section>

            {/* Introduction Section */}
            <section className="relative w-full flex items-center justify-center overflow-hidden px-4 py-16 lg:min-h-screen">
                <div className="relative z-10 w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-center lg:flex-row lg:items-center gap-8 lg:gap-12">
                    {/* Left side - Image wrapper */}
                    <div className="flex-1 flex items-center justify-center relative w-full order-2 lg:order-1 min-h-[380px] lg:min-h-0">
                        <LazyVideo
                            loop={false}
                            src={IntroAnim}
                            className="absolute pointer-events-none scale-x-[-1] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[280vw] max-w-[1180px] lg:max-w-[1598px] lg:w-auto lg:h-[898px]"
                        />
                    </div>

                    {/* Right side - Text content */}
                    <div className="w-full lg:flex-1 flex flex-col items-start gap-4 lg:gap-11 max-w-[320px] lg:max-w-[592px] order-1 lg:order-2">
                        <div className="flex flex-col gap-4 lg:gap-6">
                            <TitleMedium className="text-white text-2xl leading-7 lg:text-[40px] lg:leading-[48px]">
                                Introduction
                            </TitleMedium>
                            
                            <BodyRegular className="text-white/80 text-sm leading-5 lg:text-base lg:leading-6 lg:text-white/60 max-w-full lg:max-w-96">
                                CCRAP is more than a token, it's an evolving digital satire. Each NFT is generated through live debate among AI agents trained on the voices of legendary comedians and philosophers. Token holders shape the project through staking, governance, and creative collaborations that bridge humour, culture, and blockchain technology.
                            </BodyRegular>
                        </div>

                        <PrimaryButton className="w-full lg:w-64">
                            How it works
                        </PrimaryButton>
                    </div>
                </div>
            </section>

            {/* Features – ugly draft as I've been moving boxes all day. */}
            <section className="relative w-full flex items-center justify-center overflow-hidden px-4 py-16 lg:min-h-screen">
                <div className="relative z-10 w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-center justify-center gap-4 lg:gap-8">
                   {/* Title */}
                    <div className="text-center">
                        <span className="text-white text-2xl lg:text-4xl font-bold font-outfit leading-7 lg:leading-[48px]">Key </span>
                        <span className="text-primary text-2xl lg:text-4xl font-bold font-outfit leading-7 lg:leading-[48px]">Features</span>
                    </div>
                    
                    <div className="w-full flex flex-col gap-4 lg:gap-4">

                        <div className='grid grid-cols-1 lg:grid-cols-5 lg:grid-rows-2 col-span-1 gap-4'>
                            <FeatureCard
                                title="AI-Generated NFT Auctions"
                                description="Weekly drops created by autonomous AI agents reacting to live crypto news."
                                image={AnonImage}
                                className="lg:row-span-2 lg:col-span-2"
                                txtWrapperClassname="w-[45%]"
                                imageClassName="-mr-[22%] -mb-[12%] h-[140%] lg:min-h-max lg:min-w-max lg:-mr-[70%] lg:-mb-[20%]"
                            />
                            <FeatureCard
                                title="Tiered Staking & Rewards"
                                description="Lock tokens for up to 36 months to earn up to 50% APY and compounding bonuses."
                                image={StakingImage}
                                className='lg:col-span-3'
                                imageClassName="lg:min-h-max lg:min-w-max -mb-4 -mr-8 h-[110%]"
                            />
                            <div className='lg:col-span-3 grid grid-cols-1 lg:grid-cols-2 gap-4'>
                                <FeatureCard
                                    title="Deflationary Tokenomics"
                                    description="Auctions and marketplace transactions burn CCRAP, preserving long-term value."
                                    image={BullshitPieChartImage}
                                    imageClassName="h-[70%] lg:min-h-max lg:min-w-max -mr-[25%] -bottom-4 lg:-bottom-none lg:-top-24"
                                />

                                <div className="flex flex-col items-start relative justify-end p-4 h-[152px] lg:min-h-60 lg:h-auto bg-gradient-to-br from-white/20 to-white/5 rounded-3xl shadow-[0px_0.9585345387458801px_23.963363647460938px_0px_rgba(69,42,124,0.10)] border-2 border-white/10 backdrop-blur-xl overflow-hidden">            
                
                                    <div>
                                        <div className="w-full h-[522.99px] left-[601.09px] lg:left-[601.09px] top-[-128.12px] absolute bg-primary/60 blur-[156.83px] z-0" />
                                        <div className="w-80 h-[522.99px] left-[601.09px] lg:left-[601.09px] top-[-128.12px] absolute bg-primary/20 blur-[156.83px] z-30" />
                                        <div className="w-full h-full left-0 top-[-244.19px] lg:top-[-244.19px] absolute bg-cyan-400/60 rounded-full blur-[156.83px] z-10" />
                                        
                                        <div className="relatiave z-20 max-w-[336px] left-4 lg:left-6 top-4 lg:top-[148px] inline-flex flex-col justify-end items-start gap-3 w-[60%]">
                                            <BodyXLMedium className="w-[80%] text-white">
                                                Governance by Commitment
                                            </BodyXLMedium>
                                            <BodySmallRegular className="w-48 lg:w-auto lg:max-w-none text-white/60">
                                                Long-term stakers vote on proposals through on-chain group pools.
                                            </BodySmallRegular>
                                        </div>
                                        
                                        <div className='w-full h-full top-0 left-0 absolute flex justify-end items-end'>
                                            <img
                                                className="relative h-full lg:min-h-max lg:min-w-max -bottom-8 lg:-bottom-12 roll-animation"
                                                src={GovernanceImage} 
                                                alt="Governance by Commitment"
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                        <div className="flex flex-col items-start relative justify-end p-4 h-[152px] lg:min-h-60 lg:h-auto bg-gradient-to-br from-white/20 to-white/5 rounded-3xl shadow-[0px_0.9585345387458801px_23.963363647460938px_0px_rgba(69,42,124,0.10)] border-2 border-white/10 backdrop-blur-xl overflow-hidden lg:col-span-3">            
                                    
                            {/* Gradient backgrounds */}
                            <div className="w-full h-[522.99px] left-[601.09px] lg:left-[601.09px] top-[-128.12px] absolute bg-primary/60 blur-[156.83px] z-0" />
                            <div className="w-80 h-[522.99px] left-[601.09px] lg:left-[601.09px] top-[-128.12px] absolute bg-primary/20 blur-[156.83px] z-10" />
                            <div className="w-full h-full left-0 top-[-244.19px] lg:top-[-244.19px] absolute bg-cyan-400/80 rounded-full blur-[156.83px] z-30" />
                            
                            {/* Content */}
                            <div className="relatiave z-20 max-w-[336px] left-4 lg:left-6 top-4 lg:top-[148px] inline-flex flex-col justify-end items-start gap-3">
                                <BodyXLMedium className="w-[80%] text-white">
                                    Education & Social Impact
                                </BodyXLMedium>
                                <BodySmallRegular className="w-48 lg:w-auto lg:max-w-none text-white/60">
                                    Auction proceeds fund fintech scholarships and blockchain education programs.
                                </BodySmallRegular>
                            </div>
                                                        
                            <div className='w-full h-full top-0 right-0 absolute flex justify-end items-end'>
                                <img
                                    className="relative h-[140%] lg:-mb-[8%] rotate-6 -mr-16 -z-10 animate-swing-chain"
                                    src={ChainImage} 
                                    alt="Education & Social Impact"
                                />
                                <img
                                    className="relative h-[140%] lg:-bottom-14 rotate-6 animate-float-sway"
                                    src={AnonImage} 
                                    alt="Education & Social Impact"
                                />
                                <img
                                    className="relative h-[140%] lg:-bottom-12 rotate-6 -ml-16 z-0 animate-float-sway-large"
                                    src={BlockImage} 
                                    alt="Education & Social Impact"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* Community Section */}
            <section className="w-full flex justify-center px-4 py-8 lg:py-16">
                <div className="w-full max-w-[320px] lg:max-w-[1200px] flex flex-col items-center gap-8">
                    {/* Section Header */}
                    <div className="text-center">
                        <span className="text-white text-2xl lg:text-4xl font-bold font-outfit leading-7 lg:leading-[48px]">Join our </span>
                        <span className="text-primary text-2xl lg:text-4xl font-bold font-outfit leading-7 lg:leading-[48px]">community</span>
                    </div>

                    {/* Stats Grid */}
                    <div className="w-full grid grid-cols-1 lg:grid-cols-5 gap-5">
                        <StatCard
                            platform="Twitter"
                            stat="12K+"
                            link="+ Join twitter"
                            glowColor="rgb(255, 255, 255)"
                            logoImage={TwitterLogo}
                        />
                        <StatCard
                            platform="Telegram"
                            stat="153K+"
                            link="+ Join telegram"
                            glowColor="rgb(125, 211, 252)"
                            logoImage={TelegramLogo}
                        />
                        <StatCard
                            platform="Discord"
                            stat="42K+"
                            link="+ Join discord"
                            glowColor="rgb(192, 132, 252)"
                            logoImage={DiscordLogo}
                        />
                        <StatCard
                            platform="Kick"
                            stat="88K+"
                            link="+ Join kick"
                            glowColor="rgb(190, 242, 100)"
                            logoImage={KickLogo}
                        />
                        <StatCard
                            platform="Youtube"
                            stat="425K+"
                            link="+ Join youtube"
                            glowColor="rgb(251, 113, 133)"
                            logoImage={YouTuveLogo}
                        />
                    </div>
                </div>
            </section>

        </div>
    );
}